import * as React from 'react'

export const DocumentIcon = React.memo<JSX.IntrinsicElements['svg']>(
  (props) => {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8284 5.17157C21.5786 4.42143 22.596 4 23.6569 4H36C37.1046 4 38 4.89543 38 6V42C38 43.1046 37.1046 44 36 44H12C10.8954 44 10 43.1046 10 42V17.6569C10 16.596 10.4214 15.5786 11.1716 14.8284L20.8284 5.17157ZM22 8.24976V15.9998H14.25L22 8.24976ZM32.4998 25C33.3282 25 33.9998 25.6716 33.9998 26.5C33.9998 27.3284 33.3282 28 32.4998 28H15.4998C14.6714 28 13.9998 27.3284 13.9998 26.5C13.9998 25.6716 14.6714 25 15.4998 25H32.4998ZM15.4998 31C14.6714 31 13.9998 31.6716 13.9998 32.5C13.9998 33.3284 14.6714 34 15.4998 34H32.4998C33.3282 34 33.9998 33.3284 33.9998 32.5C33.9998 31.6716 33.3282 31 32.4998 31H15.4998ZM15.4998 37C14.6714 37 13.9998 37.6716 13.9998 38.5C13.9998 39.3284 14.6714 40 15.4998 40H32.4998C33.3282 40 33.9998 39.3284 33.9998 38.5C33.9998 37.6716 33.3282 37 32.4998 37H15.4998Z"
          fill="#0070E0"
        />
      </svg>
    )
  },
)

DocumentIcon.displayName = 'DocumentIcon'
